import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import BoxSection from '../Layout/BoxSection'

import {
    updateInputs,
} from '../../actions/contratoanual'




class Cancelacion extends Component {

	render() {

        const { id, contratoanual } = this.props
        if (!id) return null               

		return (
            <div>
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label htmlFor="fecha_rechazo" className="control-label" >Fecha de rechazo</label>
                            <input type="date" className="form-control input-sm" name="fecha_rechazo" id="fecha_rechazo" value={moment(contratoanual.get('fecha_cancelacion')).format('YYYY-MM-DD') || ''} disabled />
                        </div>
                    </div>
                </div>                
                <BoxSection title="Motivo de rechazo">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <textarea type="text" className="form-control input-sm" rows={4} value={ contratoanual.get('motivo_cancelacion') || '' } onChange={ (e) => this.props.updateInputs('solicitud.motivo_cancelacion', e.target.value) } disabled={ contratoanual.get('estado') === 0 } />
                            </div>
                        </div>
                    </div>                
                </BoxSection>
            </div>
		)
	}
}




function mapStateToProps(state) {
    return {
        id: state.contratoanual.get('id'),
        contratoanual: state.contratoanual.get('solicitud'),
    }
}



function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cancelacion)


// WEBPACK FOOTER //
// ./src/components/ContratoAnual/Cancelacion.jsx